var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPanelOpenWhite = function SvgPanelOpenWhite(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.623 10.085v-4.17q0-.26-.23-.355-.229-.096-.414.088L5.154 7.473A.72.72 0 0 0 4.928 8q0 .302.226.528l1.825 1.825q.184.184.414.088t.23-.356m-5.2 4.999q-.622 0-1.065-.442a1.45 1.45 0 0 1-.441-1.065V2.423q0-.622.441-1.065.443-.441 1.065-.441h11.154q.622 0 1.065.441.441.442.441 1.065v11.154q0 .623-.441 1.065-.442.442-1.065.442zm8.91-1.25h2.5V2.424a.24.24 0 0 0-.08-.177.25.25 0 0 0-.176-.08h-2.244zm-1.25 0V2.167h-7.66a.25.25 0 0 0-.176.08.25.25 0 0 0-.08.176v11.154q0 .096.08.177t.176.08z"
  })));
};
export default SvgPanelOpenWhite;